import { useState, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useDashboard = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [dashboardPlan, setDashboardPlan] = useState(null)

  const fetchData = useCallback(async ({ employeeId = null } = {}) => {
    setLoading(true)

    try {
      let response = null
      if (employeeId) {
        response = await RequestService.getDashboardByEmployeeId({
          employeeId,
        })
      } else {
        response = await RequestService.getDashboard()
      }

      const { data } = response
      setData(data)
      setDashboardPlan(data.userDashboard)
    } catch (e) {
      console.log('useDashboard', e)
    }
    setLoading(false)
  }, [])

  return { loading, data, dashboardPlan, fetchData }
}

export default useDashboard
